"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionActivity = useSessionActivity;
var react_1 = require("react");
var auth_1 = require("../features/apis/auth");
var sign_out_1 = require("../features/thunks/sign-out");
var hooks_1 = require("../store/hooks");
var auth_storage_1 = require("../utils/auth-storage");
function useSessionActivity() {
    var dispatch = (0, hooks_1.useAppDispatch)();
    var isSignedIn = (0, hooks_1.useAppSelector)(function (state) { return !!state.user.token; });
    var keepSignedIn = (0, hooks_1.useAppSelector)(function (state) { return !!state.user.keepSignedIn; });
    var sendHeartbeat = (0, auth_1.useHeartbeatMutation)()[0];
    (0, react_1.useEffect)(function () {
        if (!isSignedIn)
            return;
        var IDLE_LIMIT_MS = keepSignedIn ? 7 * 24 * 60 * 60 * 1000 : 60 * 60 * 1000;
        var HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;
        var ACTIVITY_WRITE_INTERVAL_MS = 5 * 1000;
        var CHECK_INTERVAL_MS = 60 * 1000;
        var ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "wheel", "touchstart"];
        var lastActivityWrite = 0;
        var isSigningOut = false;
        var sendHeartbeatIfDue = function (now) {
            var _a, _b;
            var lastActivity = (_a = (0, auth_storage_1.loadLastActivity)()) !== null && _a !== void 0 ? _a : now;
            var lastHeartbeat = (_b = (0, auth_storage_1.loadLastHeartbeat)()) !== null && _b !== void 0 ? _b : 0;
            if (lastActivity > lastHeartbeat && now - lastHeartbeat >= HEARTBEAT_INTERVAL_MS) {
                (0, auth_storage_1.saveLastHeartbeat)(now);
                sendHeartbeat();
            }
        };
        var expireIfIdle = function (now) {
            var lastActivity = (0, auth_storage_1.loadLastActivity)();
            if (isSigningOut)
                return true;
            if (lastActivity === null || now - lastActivity <= IDLE_LIMIT_MS)
                return false;
            isSigningOut = true;
            (0, auth_storage_1.markSessionExpired)();
            dispatch((0, sign_out_1.signOutThunk)());
            return true;
        };
        var recordActivity = function () {
            var now = Date.now();
            if (now - lastActivityWrite < ACTIVITY_WRITE_INTERVAL_MS)
                return;
            if (expireIfIdle(now))
                return;
            lastActivityWrite = now;
            (0, auth_storage_1.saveLastActivity)(now);
            sendHeartbeatIfDue(now);
        };
        var checkSession = function () {
            var now = Date.now();
            if (expireIfIdle(now))
                return;
            if ((0, auth_storage_1.loadLastActivity)() === null) {
                (0, auth_storage_1.saveLastActivity)(now);
            }
            sendHeartbeatIfDue(now);
        };
        checkSession();
        var intervalId = window.setInterval(checkSession, CHECK_INTERVAL_MS);
        ACTIVITY_EVENTS.forEach(function (eventName) { return window.addEventListener(eventName, recordActivity, { capture: true, passive: true }); });
        return function () {
            window.clearInterval(intervalId);
            ACTIVITY_EVENTS.forEach(function (eventName) { return window.removeEventListener(eventName, recordActivity, { capture: true }); });
        };
    }, [isSignedIn, keepSignedIn, dispatch, sendHeartbeat]);
}
